import Create from '../../../base/forms/user/Create';

const create: Create = {
  header: 'Nutzer hinzufügen',
  submit: 'Hinzufügen',
};

export default create;
